<template>
  <div class="product-card-tag">
    <div class="product-card-tag-list">
      <!-- isShowHalfLabel是购物车页底部推荐的特殊逻辑 -->
      <div v-if="isShowHalfLabel" class="half-price-tag">
        <img
          v-if="store.halfPriceRule.discount_rule_id === 1"
          src="@/assets/images/cart/half-price-tag-list.png"
          alt=""
        />
        <p v-else class="rule-discount-tag">
          <img src="@/assets/images/cart/rule_discount_light.png" alt="" />
          {{ store.halfPriceRule.discount_ratio_text }}
        </p>
      </div>
      <template v-else>
        <template v-for="(item, index) in tagList" :key="item.content">
          <div
            v-if="index < showTagNumber"
            class="product-card-tag-item"
            :class="{ 'has-stroke': item.has_stroke === 1 }"
            :style="{
              backgroundColor: item.has_fill === 1 ? item.fill : 'transparent',
              '--stroke-color': item.stroke,
              color: item.color,
            }"
          >
            {{ item.content }}
          </div>
        </template>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ProductsListItem } from '@/api/types/product';
import { getProductCardTags } from '@/composables/useProductCard';
import { useStore } from '~/store';

interface Props {
  detail: Partial<ProductsListItem>;
  isShowHalfLabel?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  isShowHalfLabel: false,
});
const store = useStore();

const showTagNumber = ref(2);

interface TagListResult {
  tagList: Array<{
    content: string;
    has_stroke?: number;
    has_fill?: number;
    fill?: string;
    stroke?: string;
    color?: string;
  }>;
  tagsForSensors: string[];
}

const tagListResult = computed<TagListResult>(() => {
  return getProductCardTags({
    productDetail: props.detail,
    maxTagCount: showTagNumber.value,
    isHalfPrice: props.isShowHalfLabel,
  }) as unknown as TagListResult;
});

const tagList = computed(() => tagListResult.value.tagList);
</script>

<style lang="scss" scoped>
.product-card-tag {
  align-items: center;
  overflow: hidden;
  min-width: 0;
  flex: 1;
  .product-card-tag-list {
    display: flex;
    flex-wrap: wrap;
    max-width: 260px;
    height: 22px;
    gap: 6px;
  }
  .product-card-tag-item {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    padding: 0 4px;
    height: 22px;
    line-height: 20px;
    white-space: nowrap;
    font-size: 12px;
    font-family: $f-pr;
    color: #080506;
    box-sizing: border-box;

    // 高分辨率屏幕边框最佳实践：使用 inset box-shadow 代替 border
    // 优点：不会被 overflow 裁剪，在高 DPI 屏幕上渲染更稳定
    &.has-stroke {
      box-shadow: 0 0 0 1px var(--stroke-color) inset;
    }
  }
  .half-price-tag {
    img {
      display: block;
      width: auto;
      height: 24px;
      aspect-ratio: auto;
    }
  }
  .rule-discount-tag {
    @include flex(center, center);

    padding: 0 6px;
    height: 22px;
    font-size: 12px;
    font-weight: bold;
    color: white;
    background: #c23000;
    img {
      margin-right: 2px;
      height: 12px;
    }
  }
}
</style>
